/** @format */

import {
	ATCEventChildSku,
	ATCEventSkuData,
	BundleData,
	ISkuLocation,
	MyCustomizerMap,
	PersonalizationState,
	ProductListSEO,
	ProductsData,
	ProductSku,
	ProductStyle,
	PromotionDetailsMapV1,
	PromotionDetailsMapV2,
	Shipping
} from '@shared/data-access/interfaces';
import { CategoryTwo, SddInventory, SkuEDDResponse } from '@pdp/data-access/interfaces';
import { createAction, props } from '@ngrx/store';

export const getProductDataAction = createAction(
	'[Product Data] Received',
	props<{
		productSkus: ProductSku[];
		productStyle: ProductStyle | Record<string, never>;
	}>()
);

export const getProductBundleDataAction = createAction(
	'[Product Bundle Data] Received',
	props<{
		bundleData: BundleData | Record<string, never>;
		bundleProductsData: ProductsData[];
	}>()
);

export const setResolvedSku = createAction(
	'[Product Selection] Set Resolved Sku',
	props<{ resolvedSku: ProductSku | null }>()
);

export const setSDDInfo = createAction(
	'[Product Selection] Set SDD Inventory',
	props<{ sdd: SddInventory | null }>()
);

export const setEDDInfo = createAction(
	'[Product Selection] Set EDD Inventory',
	props<{ eddInfo: SkuEDDResponse | null }>()
);

export const setEcommInventory = createAction(
	'[Product Selection] Set Ecomm Inventory',
	props<{ ecommInventory: ISkuLocation[] }>()
);

export const setSelectedPersonalizationOptions = createAction(
	'[Product Selection] Selected Personalization Options',
	props<{ selectedPersonalizationOptions: PersonalizationState }>()
);

export const setBopisInventory = createAction(
	'[Product Selection] Set Bopis Inventory',
	props<{ bopisInventory: ISkuLocation[] }>()
);

export const setPrimaryCategory = createAction(
	'[Product Selection] Set Primary Category',
	props<{ primaryCategory: CategoryTwo | ProductListSEO }>()
);

export const setProductHasEmptyPriceAndHasPrice = createAction(
	'[Product Selection] Set Product Has Empty Price And Has Price',
	props<{ hasEmptyPriceAndHasPrice: boolean }>()
);

export const setShippingInfo = createAction(
	'[Product Selection] Set Product Shipping Info',
	props<{ shippingInfo: Shipping | Record<string, never> }>()
);

export const setPromotionData = createAction(
	'[Product Selection] Set Promotion Data',
	props<{ promotionData: PromotionDetailsMapV1 | PromotionDetailsMapV2 }>()
);

export const setCustomProductData = createAction(
	'[Product Selection] Set Custom Product ID',
	props<{ customProductData: MyCustomizerMap }>()
);

export const setLoadingProductImages = createAction(
	'[Product Selection] Set Loading Product Images',
	props<{ loadingProductImages: boolean }>()
);

export const setFBTProducts = createAction(
	'[Product Selection] Set Freqently Bought Together Products',
	props<{ FBTProducts: [ATCEventSkuData, ...ATCEventChildSku[]] | [] }>()
);

export const setStyliticsWidgetShown = createAction(
	'[Product Selection] Set Stylitics Widget Shown',
	props<{ styliticsWidgetShown: boolean }>()
);
